import fragmentPriceRangeFields from './PriceRangeFieldsFragment.gql';
export default `
  query getProductExtendedDatas(
    $filter: ProductAttributeFilterInput,
    $configurations: [ID!]
  ) {
    products(filter: $filter) {
      items {
        url_key
        stock_status
        only_x_left_in_stock
        autori
        attribute_set_id
        description{
          html
        }
        short_description{
          html
        }
        price_range {
          ...PriceRangeFields
        }

        ... on ConfigurableProduct {
          configurable_product_options_selection(configurableOptionValueUids: $configurations) {
            options_available_for_selection {
              attribute_code
              option_value_uids
            }
            media_gallery {
              disabled
              label
              position
              url
            }
          }
          price_range {
            ...PriceRangeFields
         }
                                    
            configurable_options{
                id attribute_id
                attribute_code
                label values { value_index label uid }
            }
            variants{
                product{
                    __typename
                    name
                    sku
                    natura
                    tipologia_libro
                    uid
                    special_from_date
                    special_to_date
                    special_price
                    price_range {
                      ...PriceRangeFields
                   }
                    weight
                  }
                  attributes {
                    uid
                    label
                    code
                    value_index
                  }
            }
          }
        ... on BundleProduct {
          items {
            option_id
            position
            required
            sku
            title
            type
            uid
            options {
              id
              can_change_quantity
              is_default
              position
              uid
              quantity
              configurable_options_prices {
                configurable_option_id
                configurable_option_price
            }
              product {
                uid
                sku
                name
                stock_status
                only_x_left_in_stock
                data_pubblicazione
                special_price
                special_to_date
                special_from_date
                price_range {
                   ...PriceRangeFields
                }
                ... on ConfigurableProduct {
                  configurable_product_options_selection(configurableOptionValueUids: $configurations) {
                    options_available_for_selection {
                      attribute_code
                      option_value_uids
                    }
                    media_gallery {
                      disabled
                      label
                      position
                      url
                    }
                  }
                
                  configurable_options{
                      id attribute_id
                      attribute_code
                      label values { value_index label uid }
                  }
                  variants{
                      product{
                        __typename
                        name
                        sku
                        natura
                        tipologia_libro
                        uid
                        special_from_date
                        special_to_date
                        special_price
                        price_range {
                          ...PriceRangeFields
                       }
                        weight
                        }
                        attributes {
                          uid
                          label
                          code
                          value_index
                        }
                  }
                }
              }
            }
          }
        }

        ... on GroupedProduct {
          items {
            position
            qty
            product {
              uid
              sku
              name
              stock_status
              only_x_left_in_stock
              price_range {
                ...PriceRangeFields
             }
              thumbnail {
                url
                position
                disabled
                label
              }
            }
          }
        }

      }
    }
  }
  ${fragmentPriceRangeFields}
`;
